import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';

@Injectable({
  providedIn: 'root'
})
export class ServiceAdvisorDataService {

  constructor(
    private dataProvider: DataService
  ) { }

  getServiceAdvisorDetails(appointmentRequestModel: AppointmentRequestModel): any  {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetServiceAdvisorDetails,appointmentRequestModel).toPromise();    
}

}
